import type { ApiBindingCode, ApiIdRegisterationInfo, GenericHttpResult } from '@agunity/api-v4';

import { apiService } from '../../../api/apiService';

export const unbindSoft = (identityId: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.bindingV20UnbindSoftCreate(identityId);
    return response;
  };
};

export const unbindHard = (identityId: number) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.bindingV20UnbindHardCreate(identityId);
    return response;
  };
};

export const idCardsRegister = (data: ApiIdRegisterationInfo) => {
  return async (): Promise<GenericHttpResult<void>> => {
    const response = await apiService.accountV10IdCardsRegisterCreate(data);
    return response;
  };
};

export const getBindingToken = (identityId: number) => {
  return async (): Promise<GenericHttpResult<string>> => {
    const response = await apiService.bindingV20BindingTokenDetail(identityId);
    return response;
  };
};

export const createBindCodes = (data: number[]) => {
  return async (): Promise<GenericHttpResult<ApiBindingCode[]>> => {
    const response = await apiService.bindingV10CreateBindCodesCreate(data);
    return response;
  };
};